<template>
    <div class="row">
        <div class="col-sm">
            <div class="card-body">
                <div class="table-responsive">
                    <b-table v-if="items.length > 0" striped hover :items="items"></b-table>
                    <h5 v-else>Trenutno nema proizvoda</h5>
                </div>
                <div class="page-info-row">
                    <button :disabled="pageInfo.isFirstPage"
                            type="button"
                            class="page-info-button"
                            @click="previousPage"
                    >&#8249;</button>
                    <p v-if="pageInfo.totalElements === 0">0 od 0</p>
                    <p v-else>{{pageInfo.currentPage * this.pageSize + 1}} - {{Math.min((pageInfo.currentPage + 1) * this.pageSize, pageInfo.totalElements)}} od {{pageInfo.totalElements}}</p>
                    <button :disabled="pageInfo.isLastPage"
                            type="button"
                            class="page-info-button"
                            @click="nextPage"
                    >&#8250;</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'AdminViewItem',
        data() {
            return {
                page: 0,
                pageSize: 10
            }
        },
        created() {
            this.pageItems({ page: this.page, pageSize: this.pageSize } )
        },
        computed: {
            ...mapGetters([
                'isFetchingItems',
                'getItems',
                'getItemPageInfo'
            ]),

            items: {
                get() {
                    return this.getItems.map(item => {
                        return {
                            indeks: item.itemIndex,
                            id: item.id,
                            naziv: item.name,
                            cena: item.price,
                            popust: item.discount + '%',
                            kolicina: item.amountInStock,
                            dostupan: item.available ? 'Da' : 'Ne'
                        }
                    })
                }
            },

            pageInfo: {
                get() {
                    return this.getItemPageInfo
                }
            }
        },
        methods: {
            ...mapActions([
                'pageItems'
            ]),

            nextPage(e) {
                e.preventDefault()
                this.page += 1
                this.pageItems({ page: this.page, pageSize: this.pageSize } )
            },

            previousPage(e) {
                e.preventDefault()
                this.page -= 1
                this.pageItems({ page: this.page, pageSize: this.pageSize } )
            }
        }
    }
</script>

<style scoped>
    .page-info-row {
        display: flex;
        align-items: baseline;
        justify-content: right;
        width: 100%;
    }

    .page-info-button {
        border: none;
        margin-left: 5px;
        margin-right: 5px;
        font-size: 20px;
        font-weight: bold;
        padding: 4px 16px;
        background: #FFF;
        vertical-align: middle;
    }

    .page-info-button:hover:enabled {
        color: #42A85F;
    }
</style>
